module.exports = __webpack_public_path__ + "static/media/image-20.2f69e48f.png";